import { BasePagingResponse, BaseResponse } from 'models/_base';

export enum GuestReviewTemplateRatingCategory {
  CLEANLINESS = 'CLEANLINESS',
  COMMUNICATION = 'COMMUNICATION',
  RESPECT_HOUSE_RULES = 'RESPECT_HOUSE_RULES',
}

export interface GuestReviewTemplate {
  uid: string;
  agencyUid: string;
  author: string | null;
  title: string;
  rate: number;
  content: string;
  isGuestRecommended: boolean;
  ratingCategories: {
    category: GuestReviewTemplateRatingCategory;
    rate: number;
    comment: string | null;
  }[];
  privateFeedback: string | null;
  reviewResponse: string | null;
}

export interface GuestReviewTemplatePayload {
  agencyUid: string;
  title: string;
  content: string;
  rate: number;
  isGuestRecommended: boolean;
  privateFeedback: string | null;
  ratingCategories: {
    category: GuestReviewTemplateRatingCategory;
    rate: number;
  }[];
}

export interface GetGuestReviewTemplatesResponse {
  predefinedHostsReviews: GuestReviewTemplate[];
  metadata: {
    count: number;
  };
}

export interface GetSingleGuestReviewTemplateResponse {
  predefinedHostsReview: GuestReviewTemplate;
}

export enum AutomatedReviewLogStatus {
  SCHEDULED = 'SCHEDULED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  ALREADY_POSTED = 'ALREADY_POSTED',
  POSTED = 'POSTED',
  POSTED_MANUALLY = 'POSTED_MANUALLY',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

export enum AutomatedReviewLogAvailableAction {
  RETRY = 'RETRY',
  CANCEL = 'CANCEL',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
}

export enum AutomatedReviewLogChannel {
  AIRBNB = 'AIRBNB',
  VRBO = 'VRBO',
  HOSTFULLY = 'HOSTFULLY',
}

export interface AutomatedReviewLog {
  uid: string;
  reviewDate: string;
  reviewTemplateTitle: string;
  reviewTemplateUid: string;
  guest: {
    uid: string;
    name: string;
  };
  channel: AutomatedReviewLogChannel;
  property: {
    uid: string;
    name: string;
  };
  status: AutomatedReviewLogStatus;
  availableAction: AutomatedReviewLogAvailableAction;
}

export interface GetAutomatedReviewLogsResponse
  extends BaseResponse,
    BasePagingResponse {
  automatedReviewLogs: AutomatedReviewLog[];
}

export interface AdditionalManualReviewPayload {
  reviewTemplateUid: string;
  leadUid: string;
  propertyUid: string;
}

export interface ManualReviewAutomatedReviewLogPayload
  extends Omit<GuestReviewTemplatePayload, 'agencyUid' | 'privateFeedback'>,
    AdditionalManualReviewPayload {}

export interface ManualReviewVrboAutomatedReviewLogPayload
  extends AdditionalManualReviewPayload,
    Pick<GuestReviewTemplatePayload, 'rate'> {}
